'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

exports.default = {
	link: {
		color: _styles.colors.baseColors.blue,
		cursor: 'pointer',
		textDecoration: 'none'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMLink/styles/index.js